<template>
  <div class="container-xl">
    <Card
      title="Pessoas"
      subtitle="Exibe a lista de pessoas cadastradas, ao abrir é possível visualizar a foto e a biometria"
    >
      <table class="table table-sm table-hover table-striped">
        <thead>
          <tr>
            <PkHeader/>
            <EditHeader/>
            <DeleteHeader/>
            <StatusHeader/>
            <th data-column-id="accesslist.name" data-sortable="false">Lista</th>
            <th data-column-id="name" data-sortable="true">Nome</th>
            <th data-column-id="registration" data-sortable="true">Registro</th>
            <th data-column-id="code" data-sortable="false">Código</th>
            <th data-column-id="doc_cpf">CPF</th>
            <th data-column-id="empty_finger" data-formatter="empty" data-width="80px" data-align="center">Biometria</th>
            <th data-column-id="empty_photo" data-formatter="empty" data-width="80px" data-align="center">Foto</th>
          </tr>
        </thead>
      </table>
    </Card>
  </div>
</template>

<script>
import $ from 'jquery'
import { initGrid } from 'hennig-common'
import PkHeader from '@/components/grid/PkHeader'
import EditHeader from '@/components/grid/EditHeader'
import DeleteHeader from '@/components/grid/DeleteHeader'
import StatusHeader from '@/components/grid/StatusHeader'
import Card from '@/components/Card'

export default {
  name: 'People',
  components: {
    Card,
    StatusHeader,
    DeleteHeader,
    EditHeader,
    PkHeader
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      const addLabel = 'Nova'
      const collectionObj = 'Person'
      initGrid({
        container: $(this.$el).find('table'),
        collectionObj,
        addLabel,
        formatters: {}

      })
    }
  }
}
</script>
